export default __webpack_public_path__ + "static/media/health-min.e083f438.png";